// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import loadSrc from '@zola-helpers/client/dist/es/util/loadSrc';
import { setCookie } from '@zola-helpers/client/dist/es/util/storage';

// importing the paypal package at the top caused dupe addEventListener warnings
// thus creating the script tag manually and appending it to the head
const loadPaypalScript = () => {
  return new Promise((resolve) => {
    if (document.getElementById('paypal-src')) {
      return resolve(null);
    }

    return loadSrc(
      'https://www.paypalobjects.com/api/checkout.min.js',
      {
        id: 'paypal-src',
        type: 'text/javascript',
        'data-version-4': true,
      },
      () => resolve(null)
    );
  });
};

let paypalCheckoutInstance;

export const tokenizePaypalPayment = (data, action, checkoutInstance = paypalCheckoutInstance) =>
  checkoutInstance.tokenizePayment(data).then((payload) => {
    // the paypal payload is stored as a cookie for web-zola checkout to retrieve
    const jsonPayload = JSON.stringify(payload);
    setCookie('paypalCheckout', jsonPayload, 1);
    document.getElementById('cart-checkout-button').click();
  });

const paypal = {
  loadPaypalScript,
  tokenizePaypalPayment,
};

export default paypal;
